var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "#F5F6FA",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.164 8.605c.14 4.14 1.674 7.023 3.023 7.023 1.396 0 2.93-2.837 3.024-7.023H5.164ZM8.187.372c-1.395 0-2.93 2.837-3.023 7.023h6.093c-.14-4.14-1.674-7.023-3.07-7.023ZM12.466 7.395h3.953A8.22 8.22 0 0 0 10.047 0c1.395 1.302 2.325 4.047 2.418 7.395ZM12.466 8.605c-.093 3.348-1.024 6.093-2.42 7.395 3.443-.79 6.094-3.768 6.326-7.395h-3.906ZM3.953 8.605H0C.28 12.232 2.884 15.209 6.326 16c-1.35-1.256-2.28-4-2.373-7.395ZM3.953 7.395C4.047 4.047 4.977 1.302 6.326 0 2.884.79.279 3.767 0 7.395h3.953Z"
  })));
};

export default SvgWeb;